import { pathOr } from "ramda";
import WithRender from "../../templates/buttons/downloadTemplateButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getBaseUrl", "getFactsheet"]),
    getPPFactsheet: function () {
      if (this.getFactsheet) {
        const files = this.getFactsheet[this.ppCode]?.files;
        if (!files) {
          return null;
        }
        return Object.values(files)[0]?.path ?? null;
      }
    }
  },
  props: ["ppCode"]
});
